import type { SessionData } from "~/app/store/bffApi";
import type { PriceReferenceSelection } from "~/domains/priceReference/types";

export function canChoosePriceReferenceForCart(session: SessionData | null): boolean {
  return Boolean(session?.commerceContext.showPriceRefOnCartButton);
}

export function canSwitchToNewProductVersion(session: SessionData | null): boolean {
  return Boolean(session?.commerceContext.newProductVersionEnabled);
}

export function canShowChoosePriceReferenceAction({
  isDistributor,
  isPurchaser,
  selection,
  session,
}: {
  isDistributor: boolean;
  isPurchaser: boolean;
  selection: PriceReferenceSelection | undefined;
  session: SessionData | null;
}): boolean {
  return (
    canChoosePriceReferenceForCart(session) && (isDistributor || isPurchaser) && Boolean(selection?.options.length)
  );
}
